export default __webpack_public_path__ + "static/2174-bd11c62f6993ec4ee5c6bdf0a51916eb.gif";